import { defineCustomElement } from '@tyler-components-web/core';
import { MenuComponent } from './menu';
export * from './menu-adapter';
export * from './menu-constants';
export * from './menu-foundation';
export * from './menu';
export function defineMenuComponent() {
    defineCustomElement(MenuComponent);
}
